var VERSION = 1782442441432
export  {
	VERSION
} 
